export const FunnelStages = {
  ACCOUNT: 'Account',
  BOOMERANG: 'Boomerang',
  EMBEDDED: 'Embedded',
  INITIAL_BIND: 'Initial Bind',
  INITIAL_QUOTE: 'Initial Quote',
  LANDING: 'Landing',
  PREFILL: 'Prefill',
  PROFILE: 'Profile',
  RENTERS: 'Renters',
  SPLASH: 'Splash',
};
